import { createHmac } from 'crypto'

export const ThumborLoader = ({ src, width, quality }: any) => {
  const formatedWidth = width ? `${width}x/` : ''
  const operationUrl = `${formatedWidth}filters:format(webp):quality(${
    quality || 75
  })/${src}`

  if (process.env.THUMBOR_KEY) {
    let key = createHmac('sha1', process.env.THUMBOR_KEY)
      .update(operationUrl)
      .digest('base64')

    key = key.replace(/\+/g, '-').replace(/\//g, '_')

    return `${process.env.THUMBOR_URL}/${key}/${operationUrl}`
  } else {
    return src
  }
}

export const ThumborProportionLoader = (
  src: string,
  proportion: number,
  quality: number
) => {
  const operationUrl = `filters:proportion(${proportion}):format(webp):quality(${
    quality || 75
  })/${src}`

  if (process.env.THUMBOR_KEY) {
    let key = createHmac('sha1', process.env.THUMBOR_KEY)
      .update(operationUrl)
      .digest('base64')

    key = key.replace(/\+/g, '-').replace(/\//g, '_')

    return `${process.env.THUMBOR_URL}/${key}/${operationUrl}`
  } else {
    return src
  }
}
